import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import React, { CSSProperties, FC } from 'react';
import { APPLICATION_CONTENT_MAX_WIDTH } from 'src/pages-all/master-page/components/main-content';
import { colors } from 'src/styles/colors';
import styled from 'styled-components';

const BackgroundContent = styled.div<any>`
  max-width: 100%;
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : colors.white)};

  & .content {
    max-width: ${({ mobile }) =>
      mobile ? 'calc(100% - 32px)' : `${APPLICATION_CONTENT_MAX_WIDTH}px`};
    display: flex;
    flex: 1;
    padding: ${({ padding }) => (padding ? padding : '0')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0')};
    margin-right: auto;
    margin-left: auto;
  }
`;

type Props = {
  backgroundColor?: string;
  marginTop?: string;
  marginBottom?: string;
  padding?: string;
  style?: CSSProperties;
};

export const ContentWrapper: FC<Props> = (props) => {
  const { minTablet } = useBreakpoints();

  return (
    <BackgroundContent {...props} mobile={!minTablet}>
      <div style={props.style} className="content">
        {props.children}
      </div>
    </BackgroundContent>
  );
};
